import { render, staticRenderFns } from "./statExport.vue?vue&type=template&id=b86e4f70&"
import script from "./statExport.vue?vue&type=script&lang=js&"
export * from "./statExport.vue?vue&type=script&lang=js&"
import style0 from "./statExport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports